import { KeywordsRoutes } from './type'

const keywords = `${KeywordsRoutes.root}`

export const KeywordsPath = {
  root: keywords,
}
